<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './voucherBaseEdit';

  export default {
    name: 'addVoucher',
    components: {
      baseEdit,
    },
  };
</script>
